import { render, staticRenderFns } from "./sport.vue?vue&type=template&id=6cf882bb"
import script from "./sport.vue?vue&type=script&lang=js"
export * from "./sport.vue?vue&type=script&lang=js"
import style0 from "./sport.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/history/sport.vue
// module id = lKAJ
// module chunks = 0